import React from 'react';
import { useTranslation } from 'react-i18next';
import { FrameCard } from '@weezevent/nacre';
import EventsPicker from '../../../charts/chart/inventory/EventsPicker';
import EventModel from '../../../../models/eventModel';

export default function WidgetConfiguration({ organization, form, setForm, setFormObject, formErrors }) {
    const { t } = useTranslation();
    const [querySearch, setQuerySearch] = React.useState('');

    const [events, loadingEvents] = EventModel.useApiModel(
        {
            organizationId: organization.id,
            cache: false,
            allow_cache: false,
            query: {
                time_status: 'ongoing, upcoming'
            }
        },
        [organization]
    );

    const filteredEvents = React.useMemo(() => {
        if (loadingEvents || !events) {
            return [];
        }
        return events.sort((e1, e2) => new Date(e2.start_date).getTime() - new Date(e1.start_date).getTime());
    }, [events, loadingEvents]);

    const onChangeEvents = React.useCallback(
        selected => {
            let values = { events: selected };
            if (!form.events.length) {
                values['name'] = events.find(ev => ev.id === selected[0]).name;
            }
            setFormObject(values, true);
        },
        [events, form]
    );

    return (
        <FrameCard title={t('ticket.personal_spaces.settings.configuration.title')}>
            <EventsPicker
                label={t('ticket.ticket_design.create_design.events')}
                eventsDisplay
                events={filteredEvents}
                form={{ events: form.events }}
                onChangeEvents={onChangeEvents}
                handleSearch={value => setQuerySearch(value)}
                query={querySearch}
                disabled={loadingEvents}
            />
        </FrameCard>
    );
}
